import axiosInstance from '../../../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../../../env'
import type { SipSystematicStatusResponse } from './common.types'
import type { SipPlansOverviewResponse, UpdateIdealSipAmountRequest } from './overview.types'

const SIP_PLANS_SUMMARY_URL = `${mobileBackendUrl}/v2/portfolio/allocation-plan/sip/summary`
const UPDATE_IDEAL_SIP_AMOUNT_URL = `${mobileBackendUrl}/v2/portfolio/allocation-plan/sip/ideal`

export async function fetchSipPlansOverview(): Promise<SipPlansOverviewResponse> {
  const response = await axiosInstance.get<SipPlansOverviewResponse>(SIP_PLANS_SUMMARY_URL)
  if (!response?.data) {
    throw new Error('Failed to fetch SIP plans overview')
  }
  return response?.data
}

export async function updateIdealSipAmount(payload: UpdateIdealSipAmountRequest): Promise<void> {
  await axiosInstance.post(UPDATE_IDEAL_SIP_AMOUNT_URL, payload)
}

export async function fetchSipSystematicStatus(isin: string): Promise<SipSystematicStatusResponse> {
  const response = await axiosInstance.get<SipSystematicStatusResponse>(
    `${mobileBackendUrl}/v2/mfe-dashboard/sip-summary`,
    { params: { isin } }
  )
  return response?.data ?? {}
}
